import styled from 'styled-components';

import { screenLargerThan } from 'utils/style/responsive';
import { zindex } from 'utils/style/zindex';

export const ToastListWrapper = styled('div')`
  z-index: ${zindex.toast};
  bottom: 1.2rem;
  left: 0;
  bottom: 0;
  position: fixed;
  width: 100%;
  padding-left: 1.2rem;
  padding-bottom: 1.2rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  pointer-events: none;
  ${screenLargerThan.tablet`
      justify-content: flex-end;
  `}
`;

export const ToastListContent = styled('div')`
  margin-bottom: 45px;
  width: 100%;
  ${screenLargerThan.phone`
    width: unset;
  `}
`;
